<template>
    <v-row>
        <v-col cols="12" md="12" class="d-flex align-center elevation-1 order-details-container" style="background-color: white; color: black;">
            <v-row>
                <v-col cols="2" md="2" class="d-flex align-center">
                    <v-select label="Set PIQOB" :disabled="disableBulk" solo v-model="items" :items="PIQ_OPTIONS" style="min-width: 150px; border-radius: 25px;" @change="change_all_piq" :hide-details="true"></v-select>
                </v-col>
                <v-col v-if="dt_data.Data" cols="2" md="2" class="d-flex align-center"> <b>ORDER:</b> {{ dt_data.OrderItemId }} </v-col>
                <v-col v-if="dt_data.Data" cols="2" md="2" class="d-flex align-center"> <b>ReportName:</b> {{ dt_data.ReportName }} </v-col>
                <v-col v-if="dt_data.Data" cols="2" md="2" class="d-flex align-center"> <b>APN:</b> {{ dt_data.Data.PISearchInformation[0].AssessorInfo.APN }} </v-col>

                <v-col v-if="dt_data.Data" cols="2" md="2" class="d-flex align-center"> <b>ACQ DOC ID:</b> {{ dt_data.Data.PISearchInformation[0].AssessorInfo.ACQDOCID }} </v-col>
                <v-col v-if="dt_data.Data" cols="2" md="2" class="d-flex align-center"> <b>ACQ DATE:</b> {{ dt_data.Data.PISearchInformation[0].AssessorInfo.ACQDate }} </v-col>
                <v-col v-if="dt_data.Data" cols="2" md="2" class="d-flex align-center"> <b>TRA:</b> {{ dt_data.Data.PISearchInformation[0].AssessorInfo.TRA }} </v-col>
                <v-col v-if="dt_data.Data" cols="2" md="2" class="d-flex align-center"> <b>LAND USE CODE:</b> {{ dt_data.Data.PISearchInformation[0].AssessorInfo.LandUseCode }} </v-col>
                <v-col v-if="dt_data.Data" cols="4" md="4" class="d-flex align-center"> <b>LAND USE DESC:</b> {{ dt_data.Data.PISearchInformation[0].AssessorInfo.LandUseDesc }} </v-col>
                <v-col v-if="dt_data.Data" cols="4" md="4" class="d-flex align-center"> <b>CURRENT OWNER:</b> {{ dt_data.Data.PISearchInformation[0].AssessorInfo.CurrentOwner }} </v-col>
                <v-col v-if="dt_data.Data" cols="4" md="4" class="d-flex align-center"> <b>SITUS ADDRESS:</b> {{ dt_data.Data.PISearchInformation[0].AssessorInfo.SitusAddress }} </v-col>
                <v-col v-if="dt_data.Data" cols="4" md="4" class="d-flex align-center"> <b>MAILING ADDRESS:</b> {{ dt_data.Data.PISearchInformation[0].AssessorInfo.MailingAddress }} </v-col>
                <v-col v-if="dt_data.Data" cols="4" md="4" class="d-flex align-center"> <b>PARTIAL LEGAL:</b> {{ dt_data.Data.PISearchInformation[0].AssessorInfo.PartialLegal }} </v-col>
                <v-col cols="12" md="12" class="d-flex align-center">
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="4" md="4" class="d-flex"> <b>Search Parameters: </b> {{ searchParameter }} </v-col>
                <v-col cols="4" md="4" class="d-flex align-center">
                    <b>Borrower Information:</b>
                    &nbsp;&nbsp;{{ order.first_borrower }}&nbsp;&nbsp; &nbsp;&nbsp;{{ order.last_4_of_ssn }}&nbsp;&nbsp;|| &nbsp;&nbsp;{{ order.second_borrower }}&nbsp;&nbsp; &nbsp;&nbsp;{{ order.last_4_of_ssn2 }}&nbsp;&nbsp;
                </v-col>

                <v-col cols="4" md="4" class="d-flex align-center">
                    <b>Address:</b>
                    &nbsp;&nbsp; {{ order.address|formatAddress }} &nbsp;&nbsp; &nbsp;&nbsp;{{ order.address.county.name }}&nbsp;&nbsp; &nbsp;&nbsp;{{ order.address.state.name }}&nbsp;&nbsp;
                </v-col>
            </v-row>
        </v-col>
        <div v-if="documentsData.length > 0&&!loadingDocuments" class="documents-container">
            <h3>Search Result Supporting Documents</h3>
            <div class="screenshot-docs-container">
                <div v-for="docValue in documentsData" :key="docValue.name" class="screenshot-doc">
                    <h5>{{ docValue.name }}</h5>
                    <div class="action-column">
                        <v-btn color="primary" class="navigation-btn" v-if="docValue.site_url" @click="handleAction(docValue,'open-site')">Link to website</v-btn>
                        <v-btn color="primary" class="navigation-btn" @click="handleAction(docValue)">View file</v-btn>
                        <v-btn color="primary" class="navigation-btn" @click="handleAction(docValue,'download')">Download file</v-btn>
                    </div>
                </div>
            </div>
        </div>
        <v-col cols="12" md="12" class="d-flex align-center table-container">
            <v-data-table
                :expanded="desserts"
                v-model="selected"
                @input="handleSelection"
                @toggle-select-all="handleSelectAll"
                :headers="headers"
                :items="desserts"
                :options.sync="options"
                :server-items-length="totalDesserts"
                :loading="loading"
                class="elevation-1"
                loading-text="Loading... Please wait"
                fix-header
                :show-select="checkboxEnable"
                :items-per-page="30"
                :row-props="row_classes"
                :footer-props="{
                  'items-per-page-options': [
                    10,
                    20,
                    30,
                    40,
                    50,
                    100,
                    250,
                    500,
                  ]
                }"
            >
                <template v-slot:item.action="{ item }">
                    <runSheetDoc :order="item" :key="item.id" @selections-updated="handleSelectionsUpdated" :reasonOptions="getFieldOptions(item)" />
                </template>
                <template v-slot:item.party_1="{ item }">
                    {{ item.party_1.slice(0, 25) }}
                </template>
                <template v-slot:item.party_2="{ item }">
                    {{ item.party_2.slice(0, 25) }}
                </template>
                <template v-slot:item.rec_date="{ item }">
                    {{ item.rec_date | formatDate }}
                </template>
                <template v-slot:item.piq="{ item }">
                    <div class="select-field-container">
                        <v-select
                            label="Set PIQOB"
                            required
                            :rules="requiredRule"
                            solo
                            :hide-details="true"
                            :items="PIQ_OPTIONS"
                            item-value="name"
                            item-text="name"
                            v-model="item.piq"
                            style="width: 100%; border-radius: 25px; min-width: 120px; max-width: 120px;"
                            @change="change_piq(item)"
                        ></v-select>
                        <custom-select
                            v-bind="{options: getFieldOptions(item), placeholder: 'Select a reason', value: getReasonValue(item), onChange: (_value, selectedOption) => { handleReasonChange(item,selectedOption)}}"
                            style="min-width: 200px; max-width: 200px;"
                            :isSearchable="true"
                        />
                    </div>
                </template>

                <template #item.data-table-expand="{ item, expand, isExpanded }">
                    <td v-if="expandTable != null" class="text-start">
                        <v-btn icon @click="expand(!isExpanded)" class="v-data-table__expand-icon" :class="{ 'v-data-table__expand-icon--active': isExpanded }">
                            <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                    </td>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                    <!--<v-row v-if="item.json_field.RefDocumentId == null" class="refdivider">
            <v-col cols="12" md="12" class="d-flex align-center"></v-col>
          </v-row>-->
                    <td v-if="item.json_field" :colspan="headers.length" style="padding-left: 100px; padding-right: 100px;">
                        <v-row>
                            <v-col cols="2" sm="2" md="2" class="d-flex flex-column" style="padding: inherit; border-bottom: 1px solid white; padding-top: 2px;">
                                <div v-if="item.json_field['AliasInstrumentNumber']">
                                    <span><b>YEAR- INST NO:</b> {{ item.json_field['AliasInstrumentNumber'] }}</span>
                                </div>
                                <div v-if="item.json_field['PortionType']">
                                    <span><b>PORTION:</b> {{ item.json_field['PortionType'] }}</span>
                                </div>
                                <div v-if="item.json_field['Amount']">
                                    <span><b>DOLLAR AMOUNT:</b> {{ item.json_field['Amount'] }}</span>
                                </div>
                                <div v-if="item.json_field['RefDocumentId']">
                                    <span><b>Ref Document Id:</b> {{ item.json_field['RefDocumentId'] }}</span>
                                </div>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" class="d-flex flex-column" style="padding: inherit; border-bottom: 1px solid white; padding-top: 2px; text-align: center;">
                                <span><b>Party:</b></span>
                                <div v-for="(party,index) in item.json_field['Party']" :key="index">
                                    <span v-if="party && party['LastName']">{{ party['LastName'] }}, {{ party['FirstName'] }} {{ party['MiddleInt'] }}</span>
                                </div>
                            </v-col>
                            <v-col cols="4" sm="4" md="4" class="d-flex flex-column" style="padding: inherit; border-bottom: 1px solid white; padding-top: 2px;">
                                <div v-if="item.json_field['DocRemark']">
                                    <span><b>Remark:</b> {{ item.json_field['DocRemark'] }}</span>
                                </div>
                            </v-col>
                            <v-col cols="4" sm="4" md="4" class="d-flex flex-column" style="padding: inherit; border-bottom: 1px solid white; padding-top: 2px;">
                                <div>
                                    <span><b>Legal:</b> {{ item.legal }}</span>
                                </div>
                            </v-col>
                            <!--<v-col v-for="(value, key) in getNonEmptyItem(item.json_field)" :key="key" cols="2" sm="2" md="2"  class="d-flex flex-column" style="padding: inherit;    border-bottom: 1px solid white;padding-top: 2px;">
                    <div v-if="key == 'RecordingDate' || key == 'PostedDate'">
                        {{ key }}: {{ value| formatDate }}
                    </div>
                    <div v-else>
                        {{ key }}: {{ value }}
                    </div>
                </v-col>-->
                        </v-row>
                    </td>
                </template>
                <template v-slot:item.index_type="{ item }">
                    {{  formatKeyToLabel(item.index_type) }}
                </template>
                <template v-slot:item.doc_type="{ item }">
                    <div class="doc-codes-container" v-if="item.doc_type&& item.doc_type.length">
                        <span v-for="(code, index) in (item.doc_type).split(',')" :key="index">
                            {{ code }}
                        </span>
                    </div>
                </template>
            </v-data-table>
        </v-col>
        <filePreviewModal :dialog="documentsDialog" :data="selectedDocument" @close="documentsDialog = false;selectedDocument = null;" />
    </v-row>
</template>

<script>
import JwtService from '@/common/jwt.service'
import {
  PATCHORDERSHEET,
  GETSCRAPPEDRUNSHEETDATA
} from '@/store/actions.type'
import API_URL from '@/common/config'
import runSheetDoc from '@/components/runSheetDoc.vue'
import CustomSelect from './commonComponents/customSelect.vue'
import { PIQ_OPTIONS } from './pdf/utils/constants'
import { SITE_TYPE } from '@/constants'
import { getReasonOptionsForDocumentType } from './pdf/utils/helpers'
import filePreviewModal from './filePreviewModal.vue'
import { formatKeyToLabel } from '../utils'

export default {
  name: 'dataTable',
  components: {
    runSheetDoc,
    CustomSelect,
    filePreviewModal
  },
  data () {
    return {
      dialog: false,
      requiredRule: [
        v => !!v || 'This is required'
      ],
      totalDesserts: 0,
      desserts: [],
      loading: true,
      options: {},
      searchKey: null,
      baseAPIUrl: API_URL,
      isVisible: false,
      selected: null,
      disableBulk: true,
      PIQ_OPTIONS,
      formatted_reasons: null,
      searchParameter: null,
      documentsData: [],
      documentsDialog: false,
      selectedDocument: null,
      loadingDocuments: false,
      formatKeyToLabel: formatKeyToLabel
    }
  },
  props: {
    dataTableData: {
      count: 0,
      next: null,
      previous: null,
      results: []
    },
    headers: null,
    exportURL: null,
    expandTable: null,
    checkboxEnable: null,
    dt_data: {},
    order: null,
    document_reasons: null,
    refetchData: Function,
    fetchOnActive: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    dataTableData: {
      immediate: true,
      handler () {
        this.getDataFromApi().then((data) => {
          this.desserts = data.results
          this.totalDesserts = data.count
          if (Array.isArray(data.results)) {
            const searchParameters = data.results.map(item => item.search_type)

            if (searchParameters.length) {
              this.searchParameter = Array.from(new Set(searchParameters)).join(' || ')
            }
          }
        })
      }
    },
    options: {
      handler () {
        this.loading = true
        this.$emit('pageChanged', this.options)
      },
      deep: true
    },
    fetchOnActive (newVal) {
      if (newVal) {
        this.getData()
      }
    }
  },
  mounted () {
    this.isVisible = JwtService.checkDownload()
    this.getDataFromApi().then((data) => {
      this.desserts = data.results
      this.totalDesserts = data.count
    })
    this.getData()
  },
  methods: {
    handleSelectionsUpdated () {
      this.refetchData()
    },
    getFieldOptions (item) {
      let options = []
      const reasonFieldData = this.document_reasons
      if (reasonFieldData) {
        const allOptions = reasonFieldData['ALL_REASONS']
        if (reasonFieldData && item.json_field) {
          const docType = item.json_field['DocumentName'] || ''
          const fieldOptions = getReasonOptionsForDocumentType(reasonFieldData, docType)
          if (fieldOptions.length) {
            options = fieldOptions
          }
        }
        if (!options.length && allOptions) {
          options = allOptions.map(item => ({ label: item, value: item }))
        }
      }
      return options
    },
    getReasonValue (item) {
      let value = null
      const options = this.getFieldOptions(item)
      if (options.length) {
        value = options.find((option) => option.value === item.piq_reason)
      }
      return value
    },
    row_classes ({ item }) {
      if (item.json_field.RefDocumentId == null) {
        return { class: 'refDocDivider' }
      } else {
        return { class: 'refDoc' }
      }
    },
    handleReasonChange (item, option) {
      if (option) {
        item.piq_reason = option.value
        if (option.code) {
          item.piq = option.code
        }
        this.change_piq(item)
      } else {
        item.piq_reason = null
        item.piq = null
        this.change_piq(item)
      }
    },
    getNonEmptyItem (item) {
      let finalItem = {}
      for (const [key, value] of Object.entries(item)) {
        // if (value && key !== 'Party' && key !== 'ImageInfo' && key !== 'Company' && key !== 'Order') {
        //   finalItem[key] = value
        // }
        finalItem[key] = value
      }
      return finalItem
    },
    change_piq (sheet) {
      this.loading = true
      let payload = {
        id: sheet.id,
        piq: sheet.piq
      }
      if (Object.keys(sheet).includes('piq_reason')) {
        payload.piq_reason = sheet.piq_reason
      }
      this.$store.dispatch(PATCHORDERSHEET, payload).then(response => {
        this.loading = false
      })
    },
    change_all_piq (val) {
      this.loading = true
      this.selected.forEach((data) => {
        data.piq = val
        this.loading = true
        this.change_piq(data)
      })
      this.loading = false
    },
    handleSelection (event) {
      if (this.selected) {
        this.disableBulk = false
      } else {
        this.disableBulk = true
      }
      this.$emit('selectionChanged', { all: false, selected: this.selected })
    },
    handleSelectAll (event) {
      if (this.selected) {
        this.disableBulk = false
      } else {
        this.disableBulk = true
      }
      this.$emit('selectionChanged', { all: true, selected: this.selected })
    },
    exportCSV () {
      this.loading = true
      var form = document.createElement('form')
      form.method = 'POST'
      form.action = this.exportURL
      var paramString = this.exportURL.split('?')[1]
      var paramArray = paramString.split('&')
      paramArray.forEach((element) => {
        var input = document.createElement('input')
        input.value = element.split('=')[1]
        input.name = element.split('=')[0]
        form.appendChild(input)
      })
      document.body.appendChild(form)
      form.submit()
      this.loading = false
      form.remove()
    },
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve) => {
        let items = this.dataTableData

        setTimeout(() => {
          this.loading = false
          resolve(items)
        }, 1000)
      })
    },
    getData () {
      this.loadingDocuments = true
      this.$store.dispatch(GETSCRAPPEDRUNSHEETDATA, {
        orderId: this.order.id,
        siteType: SITE_TYPE.RECORDER,
        dataType: 'pdf'
      }).then(response => {
        if (Array.isArray(response.results) && response.results.length) {
          const documents = response.results.filter(doc => doc.data_type === 'pdf')
          this.documentsData = documents.map(doc => {
            const { Site_url: siteUrl } = doc.json_data || {}

            return {
              name: doc.content_location,
              file_path: doc.file_path,
              site_url: siteUrl || null
            }
          })
        }
      }).finally(() => {
        this.loadingDocuments = false
      })
    },
    handleAction (item, mode = 'view') {
      if (mode === 'view') {
        this.selectedDocument = item
        this.documentsDialog = true
      } else if (mode === 'open-site') {
        const { site_url: url } = item
        url && window.open(url, '_blank')
      } else {
        const { file_path: fileLink } = item
        fileLink && window.open(fileLink, '_blank')
      }
    }
  }
}
</script>

<style>
.order-data-table {
  height: 100vh;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: auto;
}

.v-data-table td {
  font-size: 10px;
  font-weight: normal;
}
.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    color: black;
    font-size: 1rem;
}
.v-chip__content {
  font-size: 10px;
}
.v-data-table td,
.v-data-table th {
  padding: 0 5px;
}
.v-application .elevation-1 {
  width: 100%;
}
.row {
  width: 100%;
  margin: auto;
}
.elevation-1 .v-chip {
  background: white !important;
}
.rtsFilter {
  font-size: 0.65rem !important;
  background: white !important;
  border-radius: 0px;
  border-right: solid 1px #f1f1f1;
}

.select-field-container{
  padding:8px 0px;
  display: flex;
  align-items: center;
  column-gap: 1em;
}

.order-details-container{
  position:sticky;
  top:0;
  left:0;
  z-index: 100;
}

.table-container{
  padding:12px 0px;
  overflow:visible;
}

.table-container .v-data-table__wrapper{
  overflow:visible;
}

.doc-codes-container{
  display: flex;
  flex-direction: column;
  row-gap: 6px;
}

.documents-container{
  padding:12px;
  margin-top:12px;
  background-color: white;
  width: 100%;
}

.screenshot-docs-container{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap:12px;
}

.navigation-btn {
  width: fit-content;
  height: 24px !important;
  border-radius: 4px !important;
  padding: 4px;
  font-size: 10px !important;
}

.action-column {
  display: flex;
  gap:12px;
}

.screenshot-doc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 2px solid #eee;
  padding:8px;
  border-radius: 8px;
  width: 100%;
}

.screenshot-doc h5 {
  font-size: 14px;
}

.documents-container h3 {
  margin-bottom: 12px;
  font-size: 20px;
}
</style>
